const AppVersionFlagList = () =>
  import(
    "@/components/AppVersionFlag/AppVersionFlagList/AppVersionFlagList.vue"
  );

export default {
  path: "app-version-flags",
  name: "app_version_flags",
  redirect: "app-version-flags/",
  meta: {
    label: "App Version Flags",
  },
  component: {
    name: "AppVersionFlags",
    render(c: any) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "app_version_flags_list",
      meta: {
        label: "List",
      },
      props: true,
      component: AppVersionFlagList,
    },
  ],
};
